module.exports = __webpack_public_path__ + "img/GNO.3dcbad07.svg";